<template>
  <div id="deployments" class="deployments">
    <transition name="fade" appear>
      <div class="card metrics-card" v-if="metrics.length > 0">
        <div class="row">
          <div class="col"><h4>{{ name }}</h4></div>
            <div class="button-container">
              <button type="button" class="btn btn-sm btn-primary" v-on:click="downloadYearlyCSV()">Download Report</button>
            </div>
          <div v-if="lastUpdate" class="col last-update text-center"><strong>Updated:</strong> {{ showLastUpdate(lastUpdate) }}</div>
        </div>
          <transition-group class="chart" name="list" appear>
            <template v-for="(metric,index) in metrics">
              <div class="bar" v-bind:class="[ {active: ((metric.date || metric.deploy.date) === date)}]" v-on:click="setDate(metric, index)" :style="{'height': barHeight(metric, metrics)+'%'}" v-bind:key="index">
                <div class="labels">
                  <div class="count">
                    {{ metric[metricProperty] }}
                  </div>
                  <div class="label">
                    {{ formatLabel(metric.label) }}
                  </div>
                </div>
              </div>
            </template>
          </transition-group>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HTTP from '@/common/http'

export default {
  name: 'MetricGraph',
  props: {
    metrics: {
      type: Array,
      default: () => []
    },
    metricProperties: {
      type: Array,
      default: () => ['count']
    },
    metricProperty: {
      type: String,
      default: () => 'count'
    },
    name: {
      type: String
    },
    date: {
      type: String
    },
    lastUpdate: {
      type: String,
      default: () => ''
    },
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'id_token',
      'settings',
      'activeType'
    ])
  },
  methods: {
    barHeight: function (metric, metrics) {
      let list = metrics.map(metric => metric[this.metricProperty])
      let max = Math.max(...list)
      return (max > 0) ? (metric[this.metricProperty] * 99 / max + 1) : 1
    },
    setDate: function (metric, metricIndex) {
      this.$emit('updateMetric', {
        eventType: 'date',
        data: {
          date: (metric.date || metric.deploy.date),
          lastUpdate: (metric.lastUpdate || metric.last_update || metric.date || metric.deploy.date),
          metricIndex: metricIndex
        }
      })
    },
    showLastUpdate: function (lastUpdate) {
      var date = this.$moment.unix(parseInt(lastUpdate))
      if (date.isValid()) {
        return date.format('MMM Do, h:mm a')
      } else if (lastUpdate == null || lastUpdate === 'unknown') {
        return 'report not found'
      } else {
        return 'unknown'
      }
    },
    formatLabel: function (label) {
      return this.$moment().month(label).format('MM')
    },
    downloadYearlyCSV: function () {
      this.flashMessage.info({
        message: `Generating yearly deployments CSV report`,
        time: 3000
      })
      HTTP.get(`ciinabox/metrics/${this.activeType}/${this.id}/csv`)
        .then((response) => {
          window.location = response.data.signedUrl
          this.flashMessage.success({
            message: `Deployments CSV report generation complete`
          })
        })
        .catch((error) => {
          this.flashMessage.error({
            message: `Failed to generate deployments CSV report : ${error.message}`
          })
        })
    }
  }
}
</script>

<style scoped src='../assets/stylesheet/deployments-graph.css'></style>



// WEBPACK FOOTER //
// src/components/DeploymentsGraph.vue